<div class="celerity-local-container">
  <div class="container">
    <div class="row">
      <nav class="col-12 mb-0 mb-md-3">
        <img *ngIf="logoUrl" class="navbar-brand mb-0 h1" src="{{logoUrl}}" alt="logo"/>
      </nav>
    </div>
    <h1 class="mb-lg-5">{{title}}</h1>
    <div class="row">
    <div class="col-12 col-lg-6 offset-lg-1 order-lg-2 mb-0 d-none d-sm-block">
        <div class="celerity-local-illustration">
          <ng-content select="[page-illustration]"></ng-content>
        </div>
      </div>
      <div class="col-12 col-lg-5">
        <ng-content select="[page-content]"></ng-content>
      </div>
    </div>
  </div>
</div>
